import React, { useState } from 'react';
import ApiService from '../../../services/ApiService';
import { toast } from 'react-toastify';
import MiniCalendar from './MiniCalendar';

const ServiceStatusModal = ({
    show,
    onClose,
    onSuccess,
    onLoadingChange,
    statusName,
    statusNameApi,
    externalId,
    propertiesId,
    fromDate,
    toDate
}) => {
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState('');
    const MAX_COMMENT_LENGTH = 500;

    const handleCommentChange = (e) => {
        const value = e.target.value;
        if (value.length <= MAX_COMMENT_LENGTH) {
            setComment(value);
        }
    };

    const handleConfirm = async () => {
        if (!statusNameApi || !externalId || !propertiesId) {
            toast.error('Missing required parameters');
            return;
        }

        setLoading(true);
        if (onLoadingChange) onLoadingChange(true);
        try {
            const response = await ApiService.post('/updateroomstatusservicedirect', {
                // make values with Underscore (ex: OUT_OF_SERVICE)
                status_name_api: statusNameApi, 
                external_id: externalId,
                properties_id: propertiesId,
                from_date: fromDate,
                to_date: toDate,
                comment: comment,
                // service_status: statusNameApi === ''
            });

            if (response?.data) {
                setComment('');
                onSuccess();
            } else {
                toast.error('Failed to update service status');
            }
        } catch (error) {
            console.error('Error updating service status:', error);
            toast.error('Failed to update service status');
        } finally {
            setLoading(false);
            if (onLoadingChange) onLoadingChange(false);
        }
    };

    const handleClose = () => {
        setComment('');
        onClose();
    };

    if (!show) return null;

    const remainingChars = MAX_COMMENT_LENGTH - comment.length;
    const isNearLimit = remainingChars < 50;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="serviceStatusModalLabel"
            aria-hidden="true"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="serviceStatusModalLabel">
                            Set Service Status to {statusName}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-3">Are you sure you want to set the service status to <strong>{statusName}</strong>?</p>
                        
                        {/* Mini Calendar showing from/to dates */}
                        {fromDate && toDate && (
                            <div className="mb-3 d-flex justify-content-center">
                                <MiniCalendar
                                    arrivalDate={fromDate}
                                    departureDate={toDate}
                                />
                            </div>
                        )}
                        
                        <div className="mb-3">
                            <label htmlFor="serviceComment" className="form-label">
                                Comment <span className="text-muted">(Optional)</span>
                            </label>
                            <textarea
                                id="serviceComment"
                                className="form-control"
                                rows="4"
                                value={comment}
                                onChange={handleCommentChange}
                                placeholder="Enter a comment..."
                                maxLength={MAX_COMMENT_LENGTH}
                                disabled={loading}
                            />
                            <div className={`mt-1 text-end ${isNearLimit ? 'text-danger' : 'text-muted'}`} style={{ fontSize: '0.875rem' }}>
                                {remainingChars} characters remaining
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-center border-0 gap-3 pt-0">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleConfirm}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Updating...
                                </>
                            ) : (
                                'Confirm'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceStatusModal;

